import React, { memo } from "react";
import { Menu, MenuItem } from "@mui/material";

type PropTypes = {
  confirmLabel?: string;
  anchorEl: HTMLElement | undefined;
  onConfirm(): void;
  onClose(): void;
};

const ConfirmPopup = ({
  anchorEl,
  confirmLabel,
  onConfirm,
  onClose,
}: PropTypes) => {
  return (
    <Menu
      id="confirm-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      <MenuItem onClick={onConfirm}>{confirmLabel || "Yes"}</MenuItem>
      <MenuItem onClick={onClose}>Cancel</MenuItem>
    </Menu>
  );
};

export default memo(ConfirmPopup);
